import ComplianceAdvanceDetailForm from './ComplianceAdvanceDetailForm';
export default ComplianceAdvanceDetailForm;